define('lib/Podio.PresenceBus',['require','underscore','jquery','lib/Podio.Push','lib/Podio.Logger','lib/Podio.PageVisibility','lib/Podio.Config','lib/Podio.Transport','lib/Podio.Event'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioPush = require('lib/Podio.Push');
  var podioLogger = require('lib/Podio.Logger');
  var PageVisibility = require('lib/Podio.PageVisibility');
  var config = require('lib/Podio.Config');
  var transport = require('lib/Podio.Transport');
  var podioEvent = require('lib/Podio.Event');

  var sendPresenceTimer;
  var presenceRefs;
  var presenceState;
  var currentRequest;
  var visible;

  var PresenceBus = function() {
    this.initialize.apply(this, arguments);
  };

  _.extend(PresenceBus.prototype, {

    initialize: function() {

      _.bindAll(this, 'startPeriodicUserEvent', 'stopPeriodicUserEvent', 'sendPresence', 'setReference', 'clearReference', 'onPageVisible', 'onPageHidden');

      this.sendPresenceTimer = null;
      this.presenceRefs = {};
      this.presenceState = {};
      this.currentRequest = null;
      this.visible = false;

      if(config.Presence) {
        // Register the main presence object
        if (config.Presence.reference) {
          this.setReference(config.Presence.reference);
        }

        PageVisibility.onVisible.add(this.onPageVisible);
        PageVisibility.onHidden.add(this.onPageHidden);
        podioEvent.bind(podioEvent.Types.unload, this.onPageHidden);

        if (PageVisibility.isVisible()) {
          this.onPageVisible();
        }
      }
    },

    startPeriodicUserEvent: function() {
      if(this.sendPresenceTimer) {
        return;
      }

      this.sendPresenceTimer = setInterval(this.sendPresence, 15000);
    },

    stopPeriodicUserEvent: function() {
      if(!this.sendPresenceTimer) {
        return;
      }

      clearInterval(this.sendPresenceTimer);
      this.sendPresenceTimer = null;
    },

    onPageVisible: function() {
      if (this.visible) {
        return;
      }

      this.visible = true;

      this.startPeriodicUserEvent();

      this.sendPresence();
    },

    onPageHidden: function() {
      if (!this.visible) {
        return;
      }

      this.visible = false;

      this.stopPeriodicUserEvent();

      this.sendPresence();
    },

    setReference: function(reference) {
      this.presenceRefs[reference.ref_type] = reference;
    },

    clearReference: function(reference) {
      // If we are on this, leave it first
      if(this.presenceState[reference.ref_type]) {
        this.leave(reference.ref_type);
      }

      delete this.presenceRefs[reference.ref_type];
    },

    enter: function(ref_type, state) {
      ref_type = ref_type || config.Presence.reference.ref_type;
      state = state || this.presenceState[ref_type] || 'viewing';

      if (!this.presenceRefs[ref_type]) {
        podioLogger.log("Presence object not registered for " + ref_type);
        return;
      }

      this.presenceState[ref_type] = state;

      if (this.visible) {
        this.sendPresence();
      }
    },

    leave: function(ref_type) {
      ref_type = ref_type || config.Presence.reference.ref_type;

      if(this.presenceState[ref_type]) {
        delete this.presenceState[ref_type];

        if (this.visible) {
          this.sendPresence();
        }
      }
    },

    sendPresence: function() {
      var self = this;
      var refs = [];

      if(this.visible) {
        _.each(_.keys(this.presenceState), function(ref_type) {
          var reference = self.presenceRefs[ref_type];

          refs.push({
            ref_type: reference.ref_type,
            ref_id: reference.ref_id,
            signature: reference.signature,
            state: self.presenceState[ref_type]
          });
        });
      }

      var eventData = {
        "event": {
          type: 'current:state',
          user_id: config.user.user_id,
          signature: config.Presence.signature,
          refs: refs
        }
      };

      var requester = function() {
        self.currentRequest = transport.post('text', config.Presence.server, {
          requestData: $.param(eventData)
        });
      };

      if (this.currentRequest) {
        this.currentRequest.always(requester);
      } else {
        requester();
      }
    }

  });

  return new PresenceBus();

});

